/**
 * Constants for LLM services
 */

/**
 * Instruction to format responses as HTML for enhanced display
 * This should be included in all system prompts
 */
export const HTML_FORMAT_INSTRUCTION = `
IMPORTANT: Format your entire response as valid HTML that can be directly inserted into a webpage.
Use appropriate HTML tags to structure your response:
- Use <h1>, <h2>, <h3> for headings
- Use <p> for paragraphs
- Use <ul>, <ol>, and <li> for lists
- Use <code> and <pre> for code blocks
- Use <strong> and <em> for emphasis
- Use <a href="..."> for links
- Use <table>, <tr>, <th>, and <td> for tabular data
- Use CSS classes that are compatible with Tailwind CSS for styling

Your response will be directly inserted into innerHTML, so ensure it's well-formatted and valid HTML. Only use html and dont prefix anything (you need to start with an opening tag end end with an closing tag)!
`;

export const OPEN_AI_CONFIG = {
  apiKey: process.env.VUE_APP_OPEN_AI_AZURE_API_KEY || '1k4gQvCjyUd4bHtkLGUWHRmMvbK4QFKYSweTOQjSaKPl0ZMOPcZFJQQJ99BDACPV0roXJ3w3AAABACOG2eau',
  endpoint: process.env.VUE_APP_OPEN_AI_AZURE_ENDPONT || 'https://fraportopenai.openai.azure.com/',
  apiVersion: process.env.VUE_APP_OPEN_AI_AZURE_API_VERSION_41 || '2024-04-01-preview',
  deploymentName: process.env.VUE_APP_OPEN_AI_AZURE_DEPLOYMENT_NAME_41 || 'gpt-40',
  temperature: 0.7,
  maxTokens: 4096,
  topP: 1,
  frequencyPenalty: 0,
  presencePenalty: 0,
  stream: false,
};

/**
 * Maximum number of retry attempts for API calls
 */
export const MAX_RETRY_ATTEMPTS = 1;

/**
 * Delay between retry attempts in milliseconds
 */
export const RETRY_DELAY_MS = 1000;